import { Routes } from '@angular/router';
import { AuthenticatedGuard } from './route.guards.ng';
import { UnsavedChangesGuard } from './unsaved-changes-guard.ng';

export enum Roles {
    ALL = 'All',
    Developer = 'Developer',
    AuctionManager = 'AuctionManager',
}

export enum RoutePaths {
    Login = 'login',
    Home = 'home',
    EditAuction = 'edit-auction',
    Verify = 'verify',
    ViewAuction = 'auction',
}

export const routes: Routes = [
    // {
    //     path: `${RoutePaths.Login}`,
    //     loadComponent: () => import('../modules/login/login.ng').then((m) => m.LoginComponent),
    // },
    {
        path: '',
        pathMatch: 'full',
        redirectTo: RoutePaths.Home,
    },
    {
        path: `${RoutePaths.Verify}`,
        loadComponent: () => import('../modules/verify/verify.ng').then((m) => m.VerifyAccountComponent),
    },
    {
        path: `${RoutePaths.EditAuction}/:auctionID`,
        loadComponent: () => import('../modules/edit-auction/edit-auction.ng').then((m) => m.EditAuctionComponent),
        canActivate: [AuthenticatedGuard],
        canDeactivate: [UnsavedChangesGuard],
        data: { Roles: [Roles.Developer, Roles.AuctionManager] },
    },
    {
        path: `${RoutePaths.ViewAuction}/:auctionRoute`,
        loadComponent: () => import('../modules/home/home.ng').then((m) => m.HomeComponent),
        data: { Roles: [Roles.ALL] },
    },
    {
        path: `${RoutePaths.Home}`,
        loadComponent: () => import('../modules/home/home.ng').then((m) => m.HomeComponent),
        data: { Roles: [Roles.ALL] },
        title: 'JAuction - Home',
    },
];
